import moment from "moment-timezone";
import {
  PM_GET_CONFERENCES_REQUEST,
  PM_GET_CONFERENCES_SUCCESS,
  PM_PUT_CONFERENCES_REQUEST,
  PM_PUT_CONFERENCES_FAILURE,
  PM_GET_CONFERENCES_FAILURE,
  PM_GET_SELECT_VALUES_SUCCESS,
  PM_GET_SELECT_VALUES_REQUEST,
  PM_GET_SELECT_VALUES_FAILURE,
  PM_RESET_FILTER,
  PM_SET_FILTER,
  PM_CHANGE_PASSCODE_FAILURE,
  PM_RESET_ERROR,
} from "../../actions/passcodeManager";

export const ownMoment = moment();

ownMoment.tz("UTC");
const filterInit = {
  confId: "",
  orderBy: "",
  orderDirection: "",
  page: 0,
  size: 10,
  hostPasscode: "",
  guestPasscode: "",
  eMail: "",
  comment: "",
  contractNumber: "",
  creationDateFrom: 0,
  creationDateTo: moment().valueOf(),
};

export const initialState = {
  requestPMConferncesInProgress: false,
  conferences: [],
  selectValues: {},
  filter: filterInit,
  sumOfAvailableConferences: undefined,
  errorMessage: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PM_RESET_FILTER:
      return {
        ...state,
        errorMessage: "",
        filter: filterInit,
      };
    case PM_SET_FILTER:
      return {
        ...state,
        errorMessage: "",
        filter: action.filter,
      };
    case PM_PUT_CONFERENCES_REQUEST:
      return {
        ...state,
        errorMessage: "",
        requestPMConferncesInProgress: true,
      };
    case PM_GET_CONFERENCES_REQUEST:
      return {
        ...state,
        errorMessage: "",
        requestPMConferncesInProgress: true,
      };
    case PM_GET_CONFERENCES_SUCCESS:
      return {
        ...state,
        errorMessage: "",
        requestPMConferncesInProgress: false,
        conferences: action.payload.audioConferences || action.payload,
        sumOfAvailableConferences: action.payload.size || undefined,
      };
    case PM_GET_SELECT_VALUES_SUCCESS:
      return {
        ...state,
        errorMessage: "",
        requestPMConferncesInProgress: false,
        selectValues: action.payload,
      };
    case PM_PUT_CONFERENCES_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        requestPMConferncesInProgress: false,
      };
    }
    case PM_GET_CONFERENCES_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        requestPMConferncesInProgress: false,
      };
    }
    case PM_GET_SELECT_VALUES_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        requestPMConferncesInProgress: false,
      };
    }
    case PM_GET_SELECT_VALUES_REQUEST:
      return {
        ...state,
        requestPMConferncesInProgress: true,
      };
    case PM_CHANGE_PASSCODE_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.message,
      };
    case PM_RESET_ERROR: {
      return {
        ...state,
        errorMessage: "",
      };
    }
    default:
      return state;
  }
};
